import React from 'react'
import '../assets/css/Product.styl'
function Product() {
        return (
            <div className="product">


               <div className="flex-justify-center box">
                    <div className="flex-column content flex-justify-center">
                        <img src={require("../assets/images/logo12.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        天气实时报大字版(快应用)
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            天气实时报大字版是专门为老年人群体提供的天气预报查询软件，能够精准的查看未来的天气情况，了解当地的天气数据。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/tqssbdzb_q/app.rpk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                        <a href="tqssbdzb_q/index.html" target="_blank">
                            <div className="detail-btn">
                                查看更多截图
                            </div>
                        </a>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_12.png")} alt="" width="324" height="514"/>
                    </div>
               </div>

            <div className="flex-justify-center box">

               <div>
                    <img src={require("../assets/images/phone_7.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo7.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        天气实时报大字版（app）
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                        天气实时报，推出专享大字版啦！字大图大，看天气不再费劲！
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/tqssbdz/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
               </div>

               <div className="flex-justify-center box">
                    <div className="flex-column content flex-justify-center">
                        <img src={require("../assets/images/logo3.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                            秀我P图
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            一键智能抠图，轻松更换背景！无须任何P图技巧，简单几步，手机也能抠出完美效果。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/xwpt/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_2.png")} alt="" width="324" height="514"/>
                    </div>
               </div>

               <div className="flex-justify-center box">
                    <div>
                        <img src={require("../assets/images/phone_6.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo6.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                            立秋天气
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            “立秋天气”是一款天气预报软件，四季更替，天气变化第一时间让你您知道，全天24小时实时为您更新天气、PM2.5空气指数，当前城市空气质量及生活建议，立秋天气将成为你贴心的天气小助手，让未来出行不会因为天气而发愁。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/lqtq/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
               </div>

                <div className="flex-justify-center box">
                    <div className="flex-column content  flex-justify-center">
                        <img src={require("../assets/images/logo8.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                            七星清理大师极速版
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            七星清理大师以帮您实时清楚的知道自己的手机状态，一键优化手机内存，清理垃圾，释放更多储存空间，是您专属的手机清理大师。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/qxqlds/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_8.png")} alt="" width="324" height="514"/>
                    </div>
               </div>
                <div className="flex-justify-center box">
                    <div>
                        <img src={require("../assets/images/phone_9.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo9.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                            天眼清理专家极速版
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            天眼清理专家极速版是一款优秀的清理软件，只需简单操作即可扫清垃圾，帮您解决手机垃圾占满手机存储的问题。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/tyqlzjjsb/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
                </div>
                {/* 旋风 */}
                <div className="flex-justify-center box">
                    <div className="flex-column content  flex-justify-center">
                        <img src={require("../assets/images/logo10.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                            旋风优化伴侣
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                            旋风优化伴侣帮您轻松解决手机问题，无需专业知识，只需简单一键。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/xfyhbl/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_10.png")} alt="" width="324" height="514"/>
                    </div>
               </div>
               <div className="flex-justify-center box">
                    <div>
                        <img src={require("../assets/images/phone_11.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo11.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        星速清理助手 
                        </div>
                        <div className="fs-20 mt-24 bold-200 fc-hui8">
                        星速清理助手帮您一键清理手机垃圾，专门的清理策略，清理更加彻底。
                        </div>
                        <a href="https://bj-zlb.oss-cn-beijing.aliyuncs.com/static_html/xsqlzs/app.apk" target="_blank">
                            <div className="download-btn">
                                下载应用
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
export default Product;
